import { put, call, select } from 'redux-saga/effects'
import { getCameraData } from 'api/getCameraData'
import { applyCameraModelsAction } from 'actions/applicationActions'
import { getAndApplyCameraDataSelector } from 'selectors'

function * getModels(filename) {
  const { cameraModels, cameraFilters, doorControllerModels, expansionControllerModels } = yield select(getAndApplyCameraDataSelector)

  if (cameraModels) {
    return {
      cameras: cameraModels,
      filters: cameraFilters,
      doorControllers: doorControllerModels,
      expansionControllers: expansionControllerModels
    }
  }

  return yield call(getCameraData, filename)
}

export function * getAndApplyCameraData(filename) {
  const cameraModels = yield call(getModels, filename)
  yield put(applyCameraModelsAction(cameraModels, filename))
}



// WEBPACK FOOTER //
// ./src/sagas/getAndApplyCameraDataSaga.js